<template>
  <b-button
    v-if="prevText"
    :ghost="!background"
    small
    :disabled="internalDisabled"
    :aria-disabled="internalDisabled"
    @click="$emit('click', $event)"
  >
    <span>{{ prevText }}</span>
  </b-button>
  <b-button
    v-else
    :ghost="!background"
    small
    :disabled="internalDisabled"
    :aria-disabled="internalDisabled"
    :icon="ArrowLeft"
    @click="$emit('click', $event)"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { ArrowLeft } from '@bigin/icons-vue'
import { BButton } from '@bigin/components/button'
import { paginationPrevEmits, paginationPrevProps } from './prev'

defineOptions({
  name: 'BPaginationPrev',
})

const props = defineProps(paginationPrevProps)
defineEmits(paginationPrevEmits)

const internalDisabled = computed(
  () => props.disabled || props.currentPage <= 1
)
</script>
